module.exports = {
  // 一般通用的翻譯
  Close: '關閉',
  Create: '建立',
  Loading: '讀取中',
  // 表單的通用翻譯
  Form: {
    account: {
      title: '帳號',
      placeholder: '在此輸入您的信箱'
    },
    password: {
      title: '密碼',
      placeholder: '在此輸入您的密碼'
    },
    login: '登入',
    register: '註冊',
    forgetPassword: '忘記密碼',
    loginWithGoogle: '使用 Google 登入',
    choiceFile: '點此選擇檔案'
  },
  // playback 的頁面相關
  HistoryDemo: {
    options: {
      autoPlay: {
        enable: '自動播放',
        disable: '取消自動播放'
      },
      complete: '快轉至結束'
    }
  },
  // 用戶的後台頁面相關
  Home: {
    drawer: {
      userInfo: '用戶資料',
      screenplayManage: '劇本管理'
    }
  },
  Editor: {
    insertMessage: '插入訊息',
    addSelection: '加入分支選項',
    setMsgSSML: '修改唸法(SSML)',
    useAdvanceSelection: '使用進階分支功能',
    setupAdvanceSelection: '設定進階分支功能',
    removeAllSelection: '移除所有分支選項',
    jump: '跳轉功能',
    set: '設置',
    add: '加入',
    hide: '隱藏',
    show: '顯示',
    hint: '提示訊息',
    audio: '音檔',
    remove: '移除'
  }
}
